import type {ReactNode} from 'react';

import {cn} from '@/utils/ui';

import Copyright from '../footer/Copyright';

export type BlankLayoutProps = {
  children: ReactNode;
  className?: string;
};

const BlankLayout = ({children, className}: BlankLayoutProps) => {
  return (
    <div className="flex h-full flex-col gap-5">
      <main className={cn('flex-1 p-5', className)}>{children}</main>
      <footer className="flex-0">
        <Copyright />
      </footer>
    </div>
  );
};

export default BlankLayout;
